export default "__VITE_ASSET__d1cd89d0__"